// extracted by mini-css-extract-plugin
export default {"container":"Orders_container__BZJDJ","content":"Orders_content__hXRFs","realContent":"Orders_realContent__oWOay"};